import { render, staticRenderFns } from "./CondensedListOfItems.vue?vue&type=template&id=189cb672&scoped=true"
import script from "./CondensedListOfItems.vue?vue&type=script&lang=js"
export * from "./CondensedListOfItems.vue?vue&type=script&lang=js"
import style0 from "./CondensedListOfItems.vue?vue&type=style&index=0&id=189cb672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189cb672",
  null
  
)

export default component.exports